// material-ui
import { alpha } from '@mui/material'

// ==============================|| DEFAULT THEME - CUSTOM SHADOWS ||============================== //

export default function CustomShadows(theme) {
    return {
        primaryButton:
            '0px 3px 1px -2px rgba(0, 0, 0, 0.2), 0px 2px 2px 0px rgba(0, 0, 0, 0.14), 0px 1px 5px 0px rgba(0, 0, 0, 0.12)',
        secondaryButton:
            '0px 3px 1px -2px rgba(0, 0, 0, 0.2), 0px 2px 2px 0px rgba(0, 0, 0, 0.14), 0px 1px 5px 0px rgba(0, 0, 0, 0.12)',
        button: '0 2px #0000000b',
        text: '0 -1px 0 rgb(0 0 0 / 12%)',
        z1: `0px 2px 8px ${alpha(theme.palette.grey[900], 0.15)}`,
        // only available in paid version
    }
}
